<!--  FORMULARIO VALIDACION DATOS -->
<p class="text-form">Solamente los campos marcados con (*) son obligatorios.</p>
<form
  action=""
  autocomplete="off"
  class="form"
  [formGroup]="formStepDataValidationLto"
>
  <!-- FECHA NACIMIENTO -->
  <mat-form-field appearance="fill">
    <mat-label>Fecha de nacimiento</mat-label>
    <input
      matInput
      [matDatepicker]="dp"
      formControlName="dateOfBirth"
      placeholder="dd/mm/yyyy"
    />
    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
    <mat-datepicker #dp></mat-datepicker>
  </mat-form-field>
  <!-- CALIFICACION UBER -->
  <mat-form-field appearance="fill">
    <mat-label>Calificación actual</mat-label>
    <input matInput formControlName="currentScore" />
  </mat-form-field>
  <!-- UBER PRO-->
  <mat-form-field appearance="fill">
    <mat-label>Uber Pro</mat-label>
    <input (keyup)="checkEvent()" matInput formControlName="uberProCategory" />
  </mat-form-field>
  <!--  SOCIO CONDUCTOR O CONDUCTOR -->
  <mat-form-field appearance="fill">
    <mat-label>Socio conductor o conductor</mat-label>
    <mat-select (selectionChange)="checkEvent()" formControlName="drivingRole">
      <mat-option *ngFor="let option of drivingRole" [value]="option.code">
        {{ option.description }}
      </mat-option>
    </mat-select>
    <mat-error
      *ngIf="
        formStepDataValidationLto.controls['drivingRole'].invalid &&
        formStepDataValidationLto.controls['drivingRole'].touched
      "
    >
      <span
        *ngIf="
          formStepDataValidationLto.controls['drivingRole'].errors &&
          formStepDataValidationLto.controls['drivingRole'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
  </mat-form-field>
  <!-- ANTIGUEDAD EN LA APP -->
  <mat-form-field appearance="fill">
    <mat-label>Antigüedad en Uber</mat-label>
    <input matInput formControlName="timeInApplication" />
  </mat-form-field>
  <!-- VIAJES/ENTREGAS TOTALES -->
  <mat-form-field appearance="fill">
    <mat-label>Viajes totales en Uber</mat-label>
    <input matInput formControlName="totalTrips" />
  </mat-form-field>
  <!-- INDICE DE ACEPTACION -->
  <mat-form-field appearance="fill">
    <mat-label>Índice de aceptación(%)</mat-label>
    <input matInput formControlName="acceptanceIndex" />
  </mat-form-field>
  <!--  INDICE DE CANCELACION -->
  <mat-form-field appearance="fill">
    <mat-label>Índice de cancelación(%)</mat-label>
    <input matInput formControlName="cancellationIndex" />
  </mat-form-field>
  <!-- PROMEDIO SIMPLE INGRESO TOTALES -->
  <mat-form-field appearance="fill">
    <mat-label>Promedio Simple de Ingresos totales ($)</mat-label>
    <input
      appNumber
      (keyup)="checkEvent()"
      matInput
      placeholder="Promedio Simple de Ingresos totales ($)"
      formControlName="averageAmountUber"
    />
    <mat-error
      *ngIf="
        formStepDataValidationLto.controls['averageAmountUber'].invalid &&
        formStepDataValidationLto.controls['averageAmountUber'].touched
      "
    >
      <span
        *ngIf="
          formStepDataValidationLto.controls['averageAmountUber'].errors &&
          formStepDataValidationLto.controls['averageAmountUber'].errors[
            'required'
          ]
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="
        formStepDataValidationLto.controls['averageAmountUber'].hasError(
          'maxlength'
        )
      "
      >Máximo 8 caracteres.
    </mat-error>
  </mat-form-field>
  <!--  RENTAS O ERES DUEÑO -->
  <mat-form-field appearance="fill">
    <mat-label>¿Rentas o eres dueño?</mat-label>
    <mat-select
      (selectionChange)="checkEvent()"
      formControlName="vehicleRelationCode"
    >
      <mat-option
        *ngFor="let option of vehicleRelation"
        [value]="option.code"
        (onSelectionChange)="validInputRentPaymentAmount($event)"
      >
        {{ option.name }}
      </mat-option>
    </mat-select>
    <mat-error
      *ngIf="
        formStepDataValidationLto.controls['vehicleRelationCode'].invalid &&
        formStepDataValidationLto.controls['vehicleRelationCode'].touched
      "
    >
      <span
        *ngIf="
          formStepDataValidationLto.controls['vehicleRelationCode'].errors &&
          formStepDataValidationLto.controls['vehicleRelationCode'].errors[
            'required'
          ]
        "
        >Debe completar este campo</span
      >
    </mat-error>
  </mat-form-field>
  <!-- CUANTO PAGAS DE RENTA -->
  <mat-form-field
    appearance="fill"
    *ngIf="
      formStepDataValidationLto.get('vehicleRelationCode')!.value === 'REVE'
    "
  >
    <mat-label>¿Cuánto paga de renta?</mat-label>
    <input
      appNumber
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese cuánto paga de renta"
      formControlName="rentAmount"
    />
    <mat-error
      *ngIf="
        formStepDataValidationLto.controls['rentAmount'].invalid &&
        formStepDataValidationLto.controls['rentAmount'].touched
      "
    >
      <span
        *ngIf="
          formStepDataValidationLto.controls['rentAmount'].errors &&
          formStepDataValidationLto.controls['rentAmount'].errors['required']
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="
        formStepDataValidationLto.controls['rentAmount'].hasError('maxlength')
      "
      >Máximo 10 caracteres.
    </mat-error>
  </mat-form-field>
  <!-- TIPO DE VEHICULO QUE MANEJAS  -->
  <mat-form-field appearance="fill">
    <mat-label>¿Que categoría de vehículo manejas?</mat-label>
    <mat-select
      (selectionChange)="checkEvent()"
      formControlName="vehicleCategoryId"
    >
      <mat-option *ngFor="let option of vehicleCategories" [value]="option.id">
        {{ option.name }}
      </mat-option>
    </mat-select>
    <mat-error
      *ngIf="
        formStepDataValidationLto.controls['vehicleCategoryId'].invalid &&
        formStepDataValidationLto.controls['vehicleCategoryId'].touched
      "
    >
      <span
        *ngIf="
          formStepDataValidationLto.controls['vehicleCategoryId'].errors &&
          formStepDataValidationLto.controls['vehicleCategoryId'].errors[
            'required'
          ]
        "
        >Debe completar este campo</span
      >
    </mat-error>
  </mat-form-field>
  <!-- DEPENDIENTES ECONOMICOS -->
  <mat-form-field
    appearance="fill"
    matTooltip="¿Cuántos dependientes económicos tienes?"
  >
    <mat-label class="size-text"
      >¿Cuántos dependientes económicos tienes?</mat-label
    >
    <input
      appNumber
      (keyup)="checkEvent()"
      matInput
      placeholder="Ingrese cantidad de dependientes"
      formControlName="totalDependents"
    />
    <mat-error
      *ngIf="
        formStepDataValidationLto.controls['totalDependents'].invalid &&
        formStepDataValidationLto.controls['totalDependents'].touched
      "
    >
      <span
        *ngIf="
          formStepDataValidationLto.controls['totalDependents'].errors &&
          formStepDataValidationLto.controls['totalDependents'].errors[
            'required'
          ]
        "
        >Debe completar este campo</span
      >
    </mat-error>
    <mat-error
      *ngIf="
        formStepDataValidationLto.controls['totalDependents'].hasError(
          'maxlength'
        )
      "
      >Máximo 2 caracteres.
    </mat-error>
  </mat-form-field>
</form>
